/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates some simple date formats to be used.
 */
export var DateTimeFormats = /*@__PURE__*/ (function (DateTimeFormats) {
    /**
     * A standard short date format is used.
     */
    DateTimeFormats[DateTimeFormats["DateShort"] = 0] = "DateShort";
    /**
     * A standard long date format is used.
     */
    DateTimeFormats[DateTimeFormats["DateLong"] = 1] = "DateLong";
    /**
     * A standard short time format is used.
     */
    DateTimeFormats[DateTimeFormats["TimeShort"] = 2] = "TimeShort";
    /**
     * A standard long time format is used.
     */
    DateTimeFormats[DateTimeFormats["TimeLong"] = 3] = "TimeLong";
    /**
     * A standard short date/time format is used.
     */
    DateTimeFormats[DateTimeFormats["DateTimeShort"] = 4] = "DateTimeShort";
    /**
     * A standard long date/time format is used.
     */
    DateTimeFormats[DateTimeFormats["DateTimeLong"] = 5] = "DateTimeLong";
    return DateTimeFormats;
})({});
/**
 * @hidden
 */
export var DateTimeFormats_$type = /*@__PURE__*/ markEnum('DateTimeFormats', 'DateShort,0|DateLong,1|TimeShort,2|TimeLong,3|DateTimeShort,4|DateTimeLong,5');
//# sourceMappingURL=DateTimeFormats.js.map
